import React from 'react';
import { MainLayout } from '@layouts';
import { withUser } from '@modules/auth';
import { getGalleryProjects } from '@modules/get-data';
import { GalleryPage } from '@sections/Gallery-Page';
import { PROCESSING_ITEMS } from "@constants";

const GalleryProjects = ({ tags, projects, queryTags }) => (
  <GalleryPage projects={projects}
               tags={tags}
               queryTags={queryTags} />
);

GalleryProjects.getLayout = (page) => {
  const { translations } = page.props;

  return (
    <MainLayout
        title={translations.t('site.galleryProjects.title')}
        processing={PROCESSING_ITEMS.GET_BLOG}
        description={translations.t('site.galleryProjects.description')}
        keywords={translations.t('site.galleryProjects.keywords')}>
      {page}
    </MainLayout>
  )
};

GalleryProjects.getInitialProps = async ({ store }) => {
  const { dispatch } = store;

  return await dispatch(getGalleryProjects());
};

export default withUser(GalleryProjects);
